import StoriesFooter from './storiesFooter'

export default StoriesFooter